import request from './service/index';
import OSS from 'ali-oss';
export function getAccessKey_Api() {
    return request({
        url: 'CMS/tools/upload2oss_image',
        method: 'get'
    });
}

export async function getOSSAuth_Api() {
    let result = {};
    await request({ url: 'CMS/tools/upload2oss_image', method: 'get' }).then(res => {
        result.oss = new OSS({
            region: res.data.region,
            endpoint: res.data.endpoint, //外网域名
            accessKeyId: res.data.access_key_id,
            accessKeySecret: res.data.access_key_secret,
            bucket: res.data.bucket,
            stsToken: res.data.security_token
        });
        result.base_path = res.data.base_path;
    }).catch(err => {
        result = 0;
    });
    return result;
}
export async function getOSSAuthFile_Api() {
    let result = {};
    await request({ url: 'CMS/tools/upload2oss_file', method: 'get' }).then(res => {
        result.oss = new OSS({
            region: res.data.region,
            endpoint: res.data.endpoint, //外网域名
            accessKeyId: res.data.access_key_id,
            accessKeySecret: res.data.access_key_secret,
            bucket: res.data.bucket,
            stsToken: res.data.security_token
        });
        result.base_path = res.data.base_path;
    }).catch(err => {
        result = 0;
    });
    return result;
}

export async function getOSSAuthLectureVideo_Api() {
    let result = {};
    await request({ url: 'CMS/tools/upload2oss_lecture', method: 'get' }).then(res => {
        result.oss = new OSS({
            region: res.data.region,
            endpoint: res.data.endpoint, //外网域名
            accessKeyId: res.data.access_key_id,
            accessKeySecret: res.data.access_key_secret,
            bucket: res.data.bucket,
            stsToken: res.data.security_token
        });
        result.base_path = res.data.base_path;
    }).catch(err => {
        result = 0;
    });
    return result;
}

export async function getOSSAuthWorksVideo_Api() {
    let result = {};
    await request({ url: 'CMS/tools/upload2oss_video', method: 'get' }).then(res => {
        result.oss = new OSS({
            region: res.data.region,
            endpoint: res.data.endpoint, //外网域名
            accessKeyId: res.data.access_key_id,
            accessKeySecret: res.data.access_key_secret,
            bucket: res.data.bucket,
            stsToken: res.data.security_token
        });
        result.base_path = res.data.base_path;
    }).catch(err => {
        result = 0;
    });
    return result;
}


// 模型上传 heritage

export async function getOSSAuthHeritageModel_Api() {
    let result = {};
    await request({ url: `/CMS/tools/upload2oss_heritage_model?mode=model`, method: 'get' }).then(res => {
        result.oss = new OSS({
            region: res.data.region,
            endpoint: res.data.endpoint, //外网域名
            accessKeyId: res.data.access_key_id,
            accessKeySecret: res.data.access_key_secret,
            bucket: res.data.bucket,
            stsToken: res.data.security_token
        });
        result.base_path = res.data.base_path;
    }).catch(err => {
        result = 0;
    });
    return result;
}
export async function getOSSAuthHeritageModelTexture_Api(model_name) {
    let result = {};
    await request({ url: `/CMS/tools/upload2oss_heritage_model?mode=texture&model_name=${model_name}`, method: 'get' }).then(res => {
        result.oss = new OSS({
            region: res.data.region,
            endpoint: res.data.endpoint, //外网域名
            accessKeyId: res.data.access_key_id,
            accessKeySecret: res.data.access_key_secret,
            bucket: res.data.bucket,
            stsToken: res.data.security_token
        });
        result.base_path = res.data.base_path;
    }).catch(err => {
        result = 0;
    });
    return result;
}




// WEBPACK FOOTER //
// ./src/apis/oss.api.js